import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as AlarmThresholdActions from '../actions/alarm-threshold.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { TechnicalError } from '@dch/products-business-logic';
import { PrepaidSettingsService } from '../../services/prepaid-settings.service';

@Injectable({
  providedIn: 'root',
})
export class AlarmThresholdEffects {
  @Effect()
  deactivateAlarmThreshold$: Observable<Action> = this.actions$.pipe(
    ofType(AlarmThresholdActions.DEACTIVATE_ALARM_THRESHOLDS),
    mergeMap((action: AlarmThresholdActions.DeactivateAlarmThresholds) =>
      this.prepaidSettingsService
        .deletePrepaidSettings(action.payload.msisdn)
        .pipe(
          map(
            (responseEntity: IEntity<any>) =>
              new AlarmThresholdActions.DeactivateAlarmThresholdsSuccess(
                responseEntity.value,
              ),
          ),
          catchError((error1: IEntity<TechnicalError>) =>
            of(
              new AlarmThresholdActions.DeactivateAlarmThresholdsFailed(
                error1.errorData as TechnicalError,
              ),
            ),
          ),
        ),
    ),
  );

  @Effect()
  activateAlarmThreshold$: Observable<Action> = this.actions$.pipe(
    ofType(AlarmThresholdActions.ACTIVATE_ALARM_THRESHOLDS),
    mergeMap((action: AlarmThresholdActions.DeactivateAlarmThresholds) =>
      this.prepaidSettingsService
        .updatePrepaidSettings(action.payload.msisdn, action.payload.threshold)
        .pipe(
          map(
            (responseEntity: IEntity<any>) =>
              new AlarmThresholdActions.ActivateAlarmThresholdsSuccess(
                responseEntity.value,
              ),
          ),
          catchError((error2: IEntity<TechnicalError>) =>
            of(
              new AlarmThresholdActions.ActivateAlarmThresholdsFailed(
                error2.errorData as TechnicalError,
              ),
            ),
          ),
        ),
    ),
  );

  @Effect()
  updateAlarmThresholds$: Observable<Action> = this.actions$.pipe(
    ofType(AlarmThresholdActions.UPDATE_THRESHOLDS),
    mergeMap((action: AlarmThresholdActions.DeactivateAlarmThresholds) =>
      this.prepaidSettingsService
        .updatePrepaidSettings(action.payload.msisdn, action.payload.threshold)
        .pipe(
          map(
            (responseEntity: IEntity<any>) =>
              new AlarmThresholdActions.UpdateThresholdsSuccess(
                responseEntity.value,
              ),
          ),
          catchError((error3: IEntity<TechnicalError>) =>
            of(
              new AlarmThresholdActions.UpdateThresholdsFailed(
                error3.errorData as TechnicalError,
              ),
            ),
          ),
        ),
    ),
  );

  constructor(
    private actions$: Actions,
    private prepaidSettingsService: PrepaidSettingsService,
  ) {}
}
